/**
 * Facts about the business that more than one page has to agree on.
 *
 * The legal pages and the footer both state these, and a privacy policy that
 * contradicts the contact link in the footer is worse than no policy at all,
 * so they are written down once here.
 */

export const COMPANY = {
  /** The name shoppers know. */
  tradingName: 'Lumera Beauty',

  /** The entity behind the contract. */
  legalName: 'Lumera Cosmetics Group',

  /** Where customer, returns and data-protection requests go. */
  email: 'hello@lumeracosmeticsgroup.com',

  /**
   * A UK trading site has to publish its registered address, and its company
   * number if it is a limited company. Both are left blank until someone
   * confirms them: the legal pages simply omit the line rather than print a
   * placeholder that looks like a fact.
   */
  companyNumber: '',
  registeredAddress: '',
}

/** Where the brand actually posts. Used by the footer and the privacy policy. */
export const SOCIALS = [
  { label: 'Instagram', handle: '@official.lumerabeauty', href: 'https://www.instagram.com/official.lumerabeauty/' },
  { label: 'TikTok', handle: '@lumera801', href: 'https://www.tiktok.com/@lumera801' },
  { label: 'Facebook', handle: 'Lumera Beauty', href: 'https://www.facebook.com/share/1dVhQgomfi/' },
] as const

/** The date the legal pages were last reviewed. Bump it whenever their wording changes. */
export const LEGAL_UPDATED = '23 September 2026'
